// Backend trả giờ UTC, đôi khi thiếu hậu tố múi giờ; thiếu thì coi là UTC.
export const parseArenaDate = (s: string): Date => {
  const hasTz = /(Z|[+-]\d{2}:?\d{2})$/.test(s);
  return new Date(hasTz ? s : `${s}Z`);
};

// Hiển thị theo giờ Việt Nam.
export const formatVn = (s?: string | null): string => {
  if (!s) return '';
  return parseArenaDate(s).toLocaleString('vi-VN', {
    timeZone: 'Asia/Ho_Chi_Minh',
    hour12: false,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const STATUS_LABEL: Record<string, string> = {
  PUBLISHED: 'Đang mở',
  JUDGING: 'Đang chấm',
  FINALIZED: 'Đã có kết quả',
  CANCELLED: 'Đã huỷ',
};

// Mã bài từ đường dẫn dạng /share/post/{id} hoặc dán thẳng mã.
export const extractPostId = (input: string): string => {
  const v = input.trim();
  const m = v.match(/\/share\/post\/([^/?#\s]+)/);
  if (m) return m[1];
  return v.replace(/[?#].*$/, '').replace(/\/+$/, '');
};

const FULL_ID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export const isFullPostId = (v: string): boolean => FULL_ID.test(v);
